import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgStar = ({ title, titleId, ...props }) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M7.65398 2.33255C7.78208 2.02457 8.21838 2.02457 8.34648 2.33255L9.76379 5.74019C9.81779 5.87003 9.9399 5.95874 10.0801 5.96998L13.7589 6.26491C14.0914 6.29156 14.2262 6.7065 13.9729 6.92351L11.17 9.32447C11.0632 9.41595 11.0166 9.5595 11.0492 9.69628L11.9055 13.2862C11.9829 13.6107 11.63 13.8671 11.3453 13.6932L8.1957 11.7695C8.07569 11.6962 7.92477 11.6962 7.80476 11.7695L4.65517 13.6932C4.3705 13.8671 4.01754 13.6107 4.09493 13.2862L4.95126 9.69628C4.98388 9.5595 4.93725 9.41595 4.83045 9.32447L2.02757 6.92351C1.77424 6.7065 1.90906 6.29156 2.24156 6.26491L5.92039 5.96998C6.06056 5.95874 6.18267 5.87003 6.23667 5.74019L7.65398 2.33255Z",
		stroke: "currentcolor",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
export default SvgStar;
